import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'spanishNumber',
    standalone: false
})
export class SpanishNumberPipe implements PipeTransform {

  localeId: string;
  constructor(@Inject(LOCALE_ID) public locale: string, private decimalPipe: DecimalPipe) {
    this.localeId = locale;
  }

  transform(value: any, noDecimal = false): string {
    if (!value) {
      return value;
    } else {
      if (String(value).includes(',')) {
        value = this.replaceSpanishFormat(String(value));
      }

      if (this.locale === 'es') {
        value = this.decimalPipe.transform(value, '1.2-2');
        return value;
      } else if (noDecimal) {
        value = this.decimalPipe.transform(value, '1.0-2', 'en-US');
        const chars = value.toString().split('.');
        if (!chars[1]) {
          return this.replaceGTS(chars[0], '.');
        } else {
          return this.replaceGTS(chars[0], '.') + ',' + chars[1];
        }

      } else {
        value = this.decimalPipe.transform(value, '1.2-2', 'en-US');
        const chars = value.toString().split('.');
        return this.replaceGTS(chars[0], '.') + ',' + chars[1];
      }
    }
  }

  /**
   * Replace the generic thousand seperator. which is comma.
   * @param val Comma replacing values
   */
  replaceGTS(val, replacement): string {
    return val.replace(/,/g, replacement);
  }

  replaceSpanishFormat(value: string): number {
    let replacedText = value.replace(/[^0-9,]*/g, '');
    replacedText = replacedText.replace(',', '.');
    return Number(replacedText);
  }

}
